import { afterEvent, defineGameCard } from '../authoring/index.js';
/** A positional death-reactive structure. */
export const AnomalyCard = defineGameCard({
    id: 'anomaly',
    gameplay: {
        type: 'STRUCTURE',
        cost: 4,
        baseStats: { attack: 0, health: 6 },
    },
    presentation: {
        name: 'Аномалия',
        description: 'Когда погибает другая карта, пока Аномалия на поле, наносит 2 урона вражеской карте напротив; если её нет — игроку.',
        glyph: {
            colors: ['transparent', '#10213a', '#ff3218', '#8e0629', '#020204'],
            rows: [
                '........2222........',
                '.......2344422......',
                '.....2234555442.....',
                '....232445544332....',
                '...23324555544332...',
                '...23444555542432...',
                '...22244555544222...',
                '..2334445555444332..',
                '.233444555555444332.',
                '..2424555555552442..',
                '..2244555555554422..',
                '.244335555555533442.',
                '.233445555555544332.',
                '..2322455555544332..',
                '...22445555554232...',
                '....244555555442....',
                '....233455554232....',
                '.....2324554432.....',
                '......23444232......',
                '.......222222.......',
            ],
        },
    },
    role: 'standalone_lab',
    abilities: [
        afterEvent({
            event: 'UnitDied',
            run(ctx) {
                const self = ctx.self;
                if (self?.cellId === undefined)
                    return;
                const opposite = ctx.q.opposingCell(self.cellId);
                const target = opposite === null ? null : ctx.q.unitAt(opposite.id);
                if (target !== null && target.controllerId !== self.controllerId) {
                    ctx.ops.dealDamage({ kind: 'unit', instanceId: target.id }, 2);
                }
                else {
                    ctx.ops.dealDamage({ kind: 'player', playerId: ctx.q.opponentOf(self.controllerId).id }, 2);
                }
            },
        }),
    ],
    ui: { mechanics: ['death'] },
});
//# sourceMappingURL=anomaly.js.map